/**************************************************
 * Nombre:       Tarjeta_Indicador
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Indicador = ({item, index, click}) => {

    return (
        <Grid
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#F7F3FE', p: 1, borderRadius: 2}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 14}}>{item.nombre}</Typography>
            </Grid>

            <Grid
                container
                justifyContent={'space-between'}
                alignItems={'flex-end'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Typography sx={{fontWeight: 600}}>{item.numero}</Typography>

                <Typography sx={{fontSize: 14}}>{item.descripcion}</Typography>

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Indicador